import React from 'react';
import { formatDate } from '../utils/dateUtils.ts';

interface MonthlyIndicator {
  id: number;
  month: string;
  value: number;
}

interface MonthlyIndicatorHistoryProps {
  indicators: MonthlyIndicator[];
  unit: string;
}

const MonthlyIndicatorHistory: React.FC<MonthlyIndicatorHistoryProps> = ({ indicators, unit }) => {
  if (!indicators.length) {
    return <p>Nenhum indicador registrado.</p>;
  }

  return (
    <ul className="indicator-history">
      {indicators.map((indicator) => (
        <li key={indicator.id}>
          <span>{formatDate(`${indicator.month}-01`)}</span>
          <strong>
            {indicator.value} {unit}
          </strong>
        </li>
      ))}
    </ul>
  );
};

export default MonthlyIndicatorHistory;
